// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"0":"Game","1":"Lobby","2":"TournamentsArena"}[chunkId] || chunkId) + "." + {"0":"8a9e1aa4","1":"bf569bad","2":"dda79c81","4":"b1f24c0d","5":"afec4f32","6":"71bdcf9d","7":"d1f8b021","8":"4ef34af0","9":"f8e1494f","10":"fc7e3a2a"}[chunkId] + ".chunk.js";
};